/**
 * usePortfolioV2
 * Fetches all data for the redesigned portfolio dashboard.
 * Uses real APIs where available, mock for balance monthly.
 */
import { useQuery } from '@tanstack/react-query';
import {
  getPortfolioBalance,
  getPortfolioByLevel,
  getPortfolioBalanceMonthly,
  getPortfolioTimeline,
} from '@/services/credit-engine.service';
import {
  getDelinquencyAnalysis,
  getDelinquencyFlow,
  getDelinquencyHistory,
} from '@/services/credit-worker.service';
import { PARTNER_ID } from '@/constants';

export function usePortfolioV2() {
  const portfolioBalance = useQuery({
    queryKey: ['portfolio-v2', 'balance'],
    queryFn: () => getPortfolioBalance(PARTNER_ID),
  });

  const portfolioByLevel = useQuery({
    queryKey: ['portfolio-v2', 'by-level'],
    queryFn: () => getPortfolioByLevel(PARTNER_ID),
  });

  const delinquencyBuckets = useQuery({
    queryKey: ['portfolio-v2', 'delinquency-buckets'],
    queryFn: () => getDelinquencyAnalysis(),
  });

  const delinquencyFlow = useQuery({
    queryKey: ['portfolio-v2', 'delinquency-flow'],
    queryFn: () => getDelinquencyFlow(),
  });

  const delinquencyHistory = useQuery({
    queryKey: ['portfolio-v2', 'delinquency-history'],
    queryFn: () => getDelinquencyHistory(),
  });

  const balanceMonthly = useQuery({
    queryKey: ['portfolio-v2', 'balance-monthly'],
    queryFn: () => getPortfolioBalanceMonthly(PARTNER_ID, 6),
  });

  const timeline = useQuery({
    queryKey: ['portfolio-v2', 'timeline'],
    queryFn: () => getPortfolioTimeline(PARTNER_ID, 6),
  });

  const isLoading = portfolioBalance.isLoading || portfolioByLevel.isLoading
    || delinquencyBuckets.isLoading || delinquencyFlow.isLoading
    || delinquencyHistory.isLoading;

  return {
    portfolioBalance: portfolioBalance.data?.data ?? null,
    portfolioByLevel: portfolioByLevel.data?.data ?? [],
    delinquencyBuckets: delinquencyBuckets.data?.data ?? null,
    delinquencyFlow: delinquencyFlow.data?.data ?? [],
    delinquencyHistory: delinquencyHistory.data?.data ?? [],
    balanceMonthly: balanceMonthly.data?.data ?? [],
    timeline: timeline.data?.data ?? [],
    isLoading,
    refetch: () => {
      void portfolioBalance.refetch();
      void portfolioByLevel.refetch();
      void delinquencyBuckets.refetch();
      void delinquencyFlow.refetch();
      void delinquencyHistory.refetch();
      void timeline.refetch();
    },
  };
}
